export const rightSidebarOpenStatus = {
  OPEN: true,
  CLOSE: false,
};

export const toggleStatus = {
  OPEN: true,
  CLOSE: false,
};

export const layout = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal",
  TWO_COLUMN: "two-column",
  SEMI_BOX: "semi-box",
};

export const avatarStatus = {
  SHOW: "show",
  HIDE: "hide",
};

export const theme = {
  DEFAULT: "default",
};

export const mode = {
  LIGHT: "light",
  DARK: "dark",
};

export const widthType = {
  FLUID: "fluid",
  BOXED: "boxed",
};

export const position = {
  FIXED: "fixed",
  SCROLLABLE: "scrollable",
};

export const topbarColor = {
  LIGHT_COLOR: "light-color",
  DARK_COLOR: "dark-color",
};

export const sidebarSize = {
  DEFAULT: "default",
  COMPACT: "compact",
  SMALL_ICON_VIEW: "small-icon-view",
  SMALL_HOVER_VIEW: "small-hover-view",
};

export const sidebarVisibility = {
  SHOW: "show",
  HIDDEN: "hidden",
};

export const sidebarMainSize = {
  LG: "lg",
  MD: "md",
  SM: "sm",
  SM_HOVER: "sm-hover",
};

export const sidebarView = {
  DEFAULT: "default",
  DETACHED: "detached",
};

export const sidebarColor = {
  DARK_BG_COLOR: "dark-bg-color",
  LIGHT_BG_COLOR: "light-bg-color",
  GRADIENT_BG_COLOR: "gradient-bg-color",
};

export const sidebarGradientColor = {
  GRADIENT_BG_COLOR: "gradient-bg-color",
  SEC_CHILD_GRADIENT_BG_COLOR: "sec-child-gradient-bg-color",
  THIRD_CHILD_GRADIENT_BG_COLOR: "third-child-gradient-bg-color",
  FOURTH_CHILD_GRADIENT_BG_COLOR: "fourth-child-gradient-bg-color",
};

export const sidebarImage = {
  NONE: "none",
  SNOW: "snow",
  OFFICE: "office",
  PATTERN: "pattern",
  BUBBLE: "bubble",
};

export const layoutThemePrimaryColor = {
  DEFAULT: "default",
  TEAL_GREEN: "teal-green",
  ROYAL_PURPLE: "royal-purple",
  COBALT_BLUE: "cobalt-blue",
};

export const loader = {
  DISABLE: "disable",
  TOP_LOADER: "top-loader",
  SPINNER: "spinner",
};
